import {useLocalSearchParams} from "expo-router";
import {OffersScreen} from "@/components/offers/OffersScreen";

export default function Offers() {
    const {orgId} = useLocalSearchParams<{orgId: string}>();
    return (
        <OffersScreen orgId={orgId}/>
    );
}